import Feature2 from './Feature2'
export default Feature2
